<template lang="pug">
  .flow-builder-view-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Vista web
        p.text-secondary.text-sm Te permite enviar al usuario una vista web integrada al flujo. Las vistas web "genérica" están disponibles para todas las cuentas y las "personalizada" sólo pertenecen a tu cuenta.
        result-description.mb-3(variable-name="view", variable-type="object")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label="Tipo de vista:", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'view_type'")
            b-form-radio-group(:options="viewTypes", buttons, button-variant="outline-secondary", size="sm", :checked="template_attribute.value", @change="viewTypeChanged(template_attribute, $event)")
          b-form-group(label="Vista web:", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'view_id'")
            k-select.disabled-white(
              placeholder="- Seleccionar vista web -",
              :options="viewsList",
              :disabled="disabled",
              :value="template_attribute.value || null",
              @input="updateTemplateAttribute(template_attribute, $event)"
            )
          b-form-group(label="Mensaje de template:", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'text'")
            vue-tribute(:options="tributeOpts")
              b-form-textarea.disabled-white(
                placeholder="Mensaje de template",
                max-rows="3",
                no-resize,
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)",
              )
          b-form-group(label="Título de botón:", description="Botón que abrirá la vista web", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'button_title'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Título de botón",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(label="Parámetros de vista web:", description="Parámetros enviados a la vista web (objeto JSON).", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'dynamic'")
            vue-tribute(:options="tributeOpts")
              b-form-textarea.disabled-white(
                no-resize,
                max-rows="100",
                placeholder="Parámetros de vista web",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
      template-connector(v-for="(connector, connector_index) in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import ResultDescription from '@/components/templates/helpers/ResultDescription.vue'
import templateCommon from '@/helpers/template-common'
import Connector from '@/components/templates/connectors/Connector.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'

const accountController = createNamespacedHelpers('account')

export default {
  mixins: [templateCommon],
  data () {
    return {
      viewTypes: [
        { text: 'Genérica', value: 'normal' },
        { text: 'Personalizada', value: 'custom' }
      ]
    }
  },
  computed: {
    ...accountController.mapState({
      views: state => state.views,
      customViews: state => state.custom_views
    }),
    viewsList () {
      let viewType = this.getAttribute('view_type')
      if (viewType.value == 'custom') {
        return this.customViews.map(v => {
          return {
            label: v.name,
            id: v.view_id
          }
        })
      } else {
        return this.views.map(v => {
          return {
            label: v.name,
            id: v.view_id
          }
        })
      }
    }
  },
  methods: {
    ...mapActions(['account/views']),
    getAccountViews () {
      let self = this

      this['account/views']({
        account_id: self.$route.params.account_id
      })
    },
    viewTypeChanged (template_attribute, value) {
      this.updateTemplateAttributeInmediatly(template_attribute, value)

      let view_id = this.getAttribute('view_id')
      if (view_id) {
        this.updateTemplateAttributeInmediatly(view_id, '')
      }
    }
  },
  mounted () {
    this.getAccountViews()
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(template_attribute))

      if (value && value.target) {
        attribute.value = value.target._value
      } else {
        attribute.value = value
      }

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })

    this.updateTemplateAttributeInmediatly = (template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    }
  },
  components: {
    ResultDescription,
    'template-connector': Connector,
    TemplateTools
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-view-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
